export default __webpack_public_path__ + "static/volta-quote-banner-e438c33e2f7c9e3e3ab6c0589040d1ac.jpg";